<template>
  <div class="app-page">
    <Header ref="header">
      <template #header-slot>
        <v-breadcrumbs
          v-if="currentProject"
          :items="[
            {
              title: 'Taskboard',
              to: { name: 'taskboard', params: { projectId: encodeID(currentProject?.id, 'p') } },
            },
            {
              title: 'Annotator',
            },
          ]"
        >
          <template #title="{ item }">
            <div class="item-flex">
              <span>{{ item.title }}</span>
            </div>
          </template>
        </v-breadcrumbs>
      </template>
      <template #extra-slot>
        <div class="review-task-header">
          <AuditToolSelect v-if="hasReviewTask && isAuditMode" v-model="auditorType" />
          <div class="review-task-header-info scrollbar">
            <TaskDatasetAndDestinationCard v-if="reviewSettings" :reviewSettings="reviewSettings" />
            <TaskProgressCard v-if="hasReviewTask" />
            <TaskActiveTimeCard v-if="hasReviewTask" />
          </div>
        </div>
      </template>
    </Header>
    <div class="main-page-div">
      <main class="main-display-area">
        <RouterView />
      </main>
    </div>
  </div>
</template>

<script setup>
import Header from '@/components/Header.vue';
import TaskProgressCard from '@/components/DatasetComponent/AnnotationTool/TaskProgressCard.vue';
import TaskActiveTimeCard from '@/components/DatasetComponent/AnnotationTool/TaskActiveTimeCard.vue';
import TaskDatasetAndDestinationCard from '@/components/DatasetComponent/AnnotationTool/TaskDatasetAndDestinationCard.vue';
import AuditToolSelect from '@/components/DatasetComponent/AnnotationTool/AuditToolSelect.vue';
import { useEditorTaskStore } from '@/stores/useEditorTaskStore.js';
import { storeToRefs } from 'pinia';
import { useStore } from 'vuex';
import { computed } from 'vue';
import { encodeID } from '@/assets/js/utils.js';

const {
  reviewSettings, hasReviewTask, isAuditMode, auditorType,
} = storeToRefs(useEditorTaskStore());

const store = useStore();

const currentProject = computed(() => store.state.projects.currentProject);

</script>

<style lang="scss" scoped>
.review-task-header {
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
  justify-content: flex-end;
}

.review-task-header-info {
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex: 1 1 auto;
  min-width: 100px;
  overflow-x: auto;
  max-width: fit-content;
}
</style>
